import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import GridLayout from '../../components/layout/GridLayout';
import Menu from '../../components/layout/Menu';
import Card from '../../components/ui/Card';
import WebcamMotionLite from '../../components/WebcamMotionLite';

interface SessionPageProps {
  isMenuOpen?: boolean;
}

export default function PilatesSessionPage({ isMenuOpen = false }: SessionPageProps) {
  return (
    <GridLayout
      isMenuOpen={isMenuOpen}
      left={<Menu />}
      main={
        <Card sx={{ bgcolor: '#111', color: '#fff', minHeight: 450 }}>

          {/* Header */}
          <Box sx={{ p: 1, display: 'flex', justifyContent: 'space-between', mb: 3 }}>
            <Typography variant="subtitle1">
              AI Pilates Posture Detect
            </Typography>

            <Typography variant="subtitle1" sx={{ color: '#34de9aab' }}>
              ● LIVE
            </Typography>
          </Box>

          {/* Camera + Motion Detection */}
          <Box
            sx={{
              height: 320,
              border: '1px solid #333',
              borderRadius: 2,
              overflow: 'hidden',
              position: 'relative'
            }}
          >
            <WebcamMotionLite />
          </Box>

          {/* Controls */}
          <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
            <Button variant="contained" color="error">
              Leave
            </Button>

            <Button
              variant="outlined"
              sx={{ color: 'white', borderColor: 'white' }}
            >
              Toggle Mic
            </Button>
          </Box>

        </Card>
      }
      right={
        <Stack spacing={2}>
          <Card>
            <Typography variant="h6">IoT Metrics</Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              Heart Rate: 92 BPM
            </Typography>
            <Typography variant="body2">
              Alignment: Stable
            </Typography>
          </Card>

          {/* Future expansion */}
          <Card>
            <Typography variant="body2" color="text.secondary">
              AI Feedback:
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              Maintain shoulder stability
            </Typography>
          </Card>
        </Stack>
      }
    />
  );
}